"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerToWindowHandler = void 0;
class WorkerToWindowHandler {
    constructor(workerSelf) {
        this.workerSelf = workerSelf;
        this.messageCounter = 0;
        this.messageReceiveCallbackBuffer = {};
    }
    onmessage(messageEvent) {
        if (typeof messageEvent.data === "object" &&
            WorkerToWindowHandler.MESSAGE_KEY_RESPONSE in messageEvent.data) {
            const message = messageEvent.data[WorkerToWindowHandler.MESSAGE_KEY_RESPONSE];
            const callback = this.messageReceiveCallbackBuffer[message.messageId];
            if (!callback) {
                throw new Error(`Received unexpected authenticated headers response for id ${message.messageId}`);
            }
            if (message.errorMessage) {
                callback.reject(new Error(message.errorMessage));
            }
            else {
                callback.resolve(new Headers(message.headersAuthenticatedRaw));
            }
            delete this.messageReceiveCallbackBuffer[message.messageId];
            return true;
        }
        return false;
    }
    buildAuthenticatedFetch() {
        return async (input, init) => {
            const inputRaw = typeof input === "string";
            const inputURL = input instanceof URL;
            const headersAuthenticated = await this.authenticateHeaders(inputRaw ? input : inputURL ? input.toString() : input.url, (inputRaw || inputURL ? init === null || init === void 0 ? void 0 : init.method : input.method) || "get", new Headers(inputURL || inputRaw || !input.headers ? init === null || init === void 0 ? void 0 : init.headers : input.headers));
            if (typeof input !== "string") {
                return global.fetch({ ...input, headers: headersAuthenticated }, { ...init });
            }
            return global.fetch(input, { ...init, headers: headersAuthenticated });
        };
    }
    authenticateHeaders(resource, method, headers) {
        const messageId = this.messageCounter;
        const promise = new Promise((resolve, reject) => {
            this.messageReceiveCallbackBuffer[messageId] = { resolve, reject };
        });
        this.messageCounter += 1;
        const message = {
            messageId,
            resource,
            method,
            headersUnauthenticatedRaw: [...headers.entries()],
        };
        this.workerSelf.postMessage({
            [WorkerToWindowHandler.MESSAGE_KEY_POST]: message,
        });
        return promise;
    }
}
exports.WorkerToWindowHandler = WorkerToWindowHandler;
WorkerToWindowHandler.MESSAGE_KEY_POST = "solid-client-authn-js.requestUnauthenticated";
WorkerToWindowHandler.MESSAGE_KEY_RESPONSE = "solid-client-authn-js.headersAuthenticated";
//# sourceMappingURL=WorkerToWindowHandler.js.map